/**
 * Static JSON under public/data read through react-query (the app's
 * QueryClientProvider is at the root). One cache entry per URL for the
 * session; a failed fetch surfaces as the query error.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export async function fetchJson<T>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status} loading ${url}`);
  return (await res.json()) as T;
}

export function useJsonFile<T>(url: string, enabled: boolean = true): UseQueryResult<T, Error> {
  return useQuery<T, Error>({
    queryKey: ['twin', 'json', url],
    queryFn: () => fetchJson<T>(url),
    staleTime: Infinity,
    enabled,
  });
}
